export function withTotal<T>(
  items: T[],
  total?: number
): T[] & { total: number } {
  return Object.defineProperty(items, 'total', {
    value: total ?? items.length,
    writable: false,
  }) as T[] & { total: number }
}
